import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { GAM_PRODUCT_SEPERATED_Rs } from '../../../analytics/constants/analytics.constants';
import * as moment from 'moment';
@Component({
	selector: 'app-screenshots',
	templateUrl: './screenshots.component.html',
	styleUrls: ['./screenshots.component.css']
})
export class ScreenshotsComponent implements OnInit, WidgetCore, OnDestroy {
	@Input() sectionclass: string;
	@Input() nodatamessage: string;
	public screenShotsData: any[] = [];
	public screenshotsMatrix: any[][] = [];
	showLoad = true;
	public sectiontitle: string;
	public colcount: number;
	public key: string;
	public isR6Enabled: Boolean = false;
	public hasData: boolean = false;
	public isR102: boolean = false;
	public isR103: boolean = false;
	public filterGamCampaigns: string;
	public isGamSeperated_R: boolean = false;

	public startDate: any;
	public endDate: any;
	public reloadSubscription;
	public widgetDataSubscription;

	constructor(private analyticsService: AnalyticsService, private analyticsDataModel: AnalyticsDataModel) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit() {
		this.isR102 = this.analyticsDataModel.config.partner.directoryName === 'default-r102' ? true : false;
		this.isR103 =
			this.analyticsDataModel.config.partner.directoryName === 'default-r103' ||
			this.analyticsDataModel.config.partner.directoryName === 'entravision-r103'
				? true
				: false;
		this.isGamSeperated_R = GAM_PRODUCT_SEPERATED_Rs.includes(this.analyticsDataModel.config.directoryName);
		this.filterGamCampaigns =
			this.isGamSeperated_R && this.analyticsDataModel.getCurrentPath() == 'gam'
				? 'gamOnly'
				: (this.isGamSeperated_R && this.analyticsDataModel.getCurrentPath() == 'display') ||
				  (this.isGamSeperated_R && this.analyticsDataModel.getCurrentPath() == 'preroll')
				? 'nonGamOnly'
				: 'default';
		this.requestData();
		if (this.sectionclass.toLowerCase().includes('v6')) {
			this.isR6Enabled = true;
		}
		this.nodatamessage =
			UtilityService.isUndefinedOrNull(this.nodatamessage) ||
			this.nodatamessage == 'null' ||
			this.nodatamessage == 'undefined'
				? 'No Data Available'
				: this.nodatamessage;
	}

	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData() {
		this.showLoad = true;
		this.hasData = false;
		this.widgetDataSubscription = this.analyticsService
			.processWidgetRequest(this.key, null, null, null, this.filterGamCampaigns)
			.subscribe((res: any) => {
				this.screenShotsData = [];
				this.screenshotsMatrix = [];
				this.showLoad = false;
				if (res.success && res.data.length > 0) {
					this.processResponseData(res.data);
					this.hasData = true;
				}
				this.startDate = moment(this.analyticsDataModel.startDate).format('MM-DD-YYYY');
				this.endDate = moment(this.analyticsDataModel.endDate).format('MM-DD-YYYY');
			});
	}

	processResponseData(responseData: any) {
		for (const response of responseData) {
			const obj = {
				imageURL: response.path,
				date: response.date,
				url: response.url,
				completeURL: response.full_url
			};
			this.screenShotsData.push(obj);
		}
		this.screenshotsMatrix = UtilityService.listToMatrix(this.screenShotsData, this.colcount);
	}

	previewScreenshot(imageURL: string) {
		const win = window.open(imageURL, '_blank');
		win.focus();
	}
}
